import { Text } from "rebass";
import styled from "styled-components";

const TextLowercase = styled(Text)`
  text-transform: lowercase;
`;

export default TextLowercase;
